import React from "react";

let includedAchievementConditions = [];
export class AchievementCondition {
  public id: number;
  public name: string;
  public label: string;

  constructor(data: { id: number; name: string; label: string }) {
    this.id = data.id;
    this.name = data.name;
    this.label = data.label;
    this.save();
  }
  save() {
    includedAchievementConditions.push(this);
  }
  static includedAchivementConditions() {
    return includedAchievementConditions;
  }

  static findByName(name) {
    return includedAchievementConditions.find(
      (condition) => condition.name == name
    );
  }
}
